var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68329 6.6232C3.68329 7.03741 4.01907 7.3732 4.43329 7.3732C4.8475 7.3732 5.18329 7.03741 5.18329 6.6232H3.68329ZM9.96664 11.4066C9.55243 11.4066 9.21664 11.7423 9.21664 12.1566C9.21664 12.5708 9.55243 12.9066 9.96664 12.9066V11.4066ZM18.4501 20.0898C18.4501 18.2698 17.3436 16.7139 15.7437 15.6473C14.1386 14.5772 11.9643 13.9398 9.60004 13.9398V15.4398C11.7095 15.4398 13.5852 16.0111 14.9117 16.8954C16.2434 17.7832 16.9501 18.9273 16.9501 20.0898H18.4501ZM9.60004 13.9398C7.23581 13.9398 5.06151 14.5772 3.45637 15.6473C1.85647 16.7139 0.75 18.2698 0.75 20.0898H2.25C2.25 18.9273 2.95672 17.7832 4.28843 16.8954C5.61489 16.0111 7.49062 15.4398 9.60004 15.4398V13.9398ZM5.18329 6.6232C5.18329 3.97951 7.32295 1.83984 9.96664 1.83984V0.339844C6.49452 0.339843 3.68329 3.15108 3.68329 6.6232H5.18329ZM9.96664 1.83984C12.6103 1.83984 14.75 3.97951 14.75 6.6232H16.25C16.25 3.15108 13.4388 0.339844 9.96664 0.339844V1.83984ZM14.75 6.6232C14.75 9.2669 12.6103 11.4066 9.96664 11.4066V12.9066C13.4388 12.9066 16.25 10.0953 16.25 6.6232H14.75Z",
    fill: "#565656"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.e330d240ff159810a0863688e3ec02f9.svg";
export { ForwardRef as ReactComponent };